



































































































import Vue from "vue";
import EhrButton from "./interface/EhrButton.vue";
import { RepositoryFactory } from "./repositories/RepositoryFactory";
const UserRepository = RepositoryFactory.get("user");
import * as SwalUtils from "./utils/SwalUtils";
import { minLength, required } from "vuelidate/lib/validators";
declare var GLOBAL_logo: string;

export default Vue.extend({
  name: "reset-password",
  components: { EhrButton },
  data() {
    return {
      password: "",
      confirmPassword: "",
      logo: GLOBAL_logo,
      loading: false,
      resetComplete: false,
    };
  },
  methods: {
    async doResetPassword() {
      if (!this.passwordsMatch) {
        SwalUtils.DisplayErrorToast(
          "Uw ingevoerde wachtwoorden komen niet overeen."
        );
      } else {
        var urlString = window.location.href;
        var url = new URL(urlString);
        var token = url.searchParams.get("token");
        const res = await UserRepository.resetPassword(this.password, token)
          .then(function(res) {
            SwalUtils.DisplaySuccessToast(
              "Uw wachtwoord werd opnieuw ingesteld. U kan nu aanmelden."
            );
          })
          .catch(function(err) {
            SwalUtils.DisplayErrorToast("Er is iets foutgelopen.");
          });
        this.resetComplete = true;
      }
    },
  },
  computed: {
    passwordsMatch(): boolean {
      return this.password == this.confirmPassword;
    },
    isEmptyForm(): boolean {
      return this.password == "" && this.confirmPassword == "";
    },
    isEmptyConfirm(): boolean {
      return this.confirmPassword == "";
    },
    baseURL() {
      return document.baseURI;
    },
    isNewPersoneelslid() {
      var urlString = window.location.href;
      var url = new URL(urlString);
      return url.searchParams.get("isNew") == "true";
    },
  },
  validations() {
    if (!this.isEmptyForm) {
      return {
        password: {
          required,
          minLength: minLength(10),
        },
      };
    } else {
      return {};
    }
  },
});
